import { useEffect } from "react";
import { Routes, useNavigate } from "react-router-dom";
import renderRoutes from "../routes/utils/renderRoutes";

export default function InspiraAirlines() {
  return (
    <>
      <Routes>{renderRoutes()}</Routes>
    </>
  );
}
